<template>
    <el-drawer :title="form.id ? '编辑' : '添加'" :visible.sync="drawer" :modal="true" :wrapperClosable="false" size="50%"
        @close="closeDrawer" :modal-append-to-body="false" :direction="direction">

        <!-- title -->
        <div class="drawer_form">
            <el-form :model="form" status-icon :rules="formRules" ref="form" label-width="120px" class="demo-ruleForm">
                <div class="form-content">
                    <!-- 模板信息部分 -->
                    <span class="section-title">模板信息</span>
                    <div class="form-section">
                        <el-form-item label="评课标准名称" prop="">
                            <el-input type="text" v-model="form.templateName" placeholder="请输入评课标准名称" autocomplete="off"
                                class="form-input"></el-input>
                        </el-form-item>
                        <el-form-item label="评课附加提示词" prop="">
                            <el-input type="textarea" rows="4" v-model="form.background" placeholder="请输入评课附加提示词"
                                autocomplete="off" class="form-textarea"></el-input>
                        </el-form-item>
                    </div>

                    <!-- 指标项部分 -->
                    <span class="section-title">指标项</span>
                    <div class="form-section">
                        <!-- 编辑模式下，当不可编辑时显示蒙层 -->
                        <div v-if="form.id && !editable" class="edit-overlay">
                            <div class="edit-overlay-text">禁止编辑</div>
                        </div>
                        <!-- 直接在div上绑定点击事件，确保可点击性 -->
                        <div v-if="editable" @click="handleAddGroup" class="add-card-wrapper">
                            <el-card shadow="hover" class="add-card">
                                <div class="add-card-content">+ 添加指标项</div>
                            </el-card>
                        </div>

                        <!-- 指标卡片列表 -->
                        <el-card v-for="(item, index) in rule_selected_lists" :key="index" shadow="hover"
                            class="rule-card">
                            <div class="group-header">
                                <el-input type="text" v-model="item.name" placeholder="请输入指标项名称"
                                    class="group-name-input" />
                                <el-button type="danger" size="mini" icon="el-icon-delete"
                                    @click.stop="handleGroupDel(index)" class="delete-btn">删除</el-button>
                            </div>
                            <div class="select-container">
                                <el-select filterable remote reserve-keyword placeholder="关联指标,支持模糊查询"
                                    :remote-method="remoteMethodRule" @change="(val) => handleChange(val, item)"
                                    v-model="item.selectedIds" multiple class="rule-select">
                                    <el-option v-for="rule_item in secondLevelRules" :key="rule_item.id"
                                        :label="rule_item.name" :value="rule_item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <el-table :data="item.children || []" size="small" class="score-table">
                                <el-table-column prop="name" label="指标" align="center"
                                    class-name="table-column"></el-table-column>
                                <el-table-column prop="" label="分数" align="center" class-name="table-column">
                                    <template slot-scope="scope">
                                        <el-input type="number" v-model.number="scope.row.maxScore" placeholder="请输入分数"
                                            class="score-input" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </div>
                </div>

                <!-- 底部按钮区域 -->
                <div class="form-footer">
                    <el-button @click="closeDrawer" class="cancel-btn">取消</el-button>
                    <el-button @click="onSubmit" type="primary" class="submit-btn">添加</el-button>
                </div>
            </el-form>
        </div>
    </el-drawer>
</template>

<script>
import { save, rule_list, get_module, module_del_rule } from '@/request/api/module'
export default {
    components: {
    },
    data() {
        return {
            drawer: true, //表单
            direction: 'rtl',//抽屉方向
            loading: false,
            form: {
                id: '',
                templateName: '', //名称
                background: '',//文化背景
                level: 2,
                rules: [
                ],
            },
            rule_selected_lists: [],//选择的指标
            secondLevelRules: [],//二级指标
            editable: true, //判断指标项是否可编辑
            formRules: {
                templateName: [
                    { required: true, message: '名称必填', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
        this.form.id = this.$route.query.id || ''
        this.init()
    },
    methods: {


        init() {
            // 如果有id，则是编辑模式，需要获取数据
            if (this.form.id) {
                this.get_module_data()
            } else {
                // 暂时只调用必要的方法
                this.get_rules()
            }
        },
        // 获取模块数据（编辑模式使用）
        get_module_data() {

            get_module(this.form.id).then(res => {
                let _t = res.data
                let _r = res.data.rules
                let _rule = this.secondLevelRules;
                this.editable = res.data.editable
                this.form.templateName = res.data.templateName;
                this.form.id = res.data.id;
                this.form.description = res.data.description;
                // 确保level是数字类型，与el-option的value保持一致
                this.form.level = Number(res.data.level) || 2;
                // this.samples = res.data.samples

                _r.forEach(item => {
                    // 确保item有children属性
                    if (!item.children) {
                        item.children = []
                    }
                    // 确保item有selectedIds属性
                    if (!item.selectedIds) {
                        item.selectedIds = []
                    }
                    if (item.children.length > 0) {
                        item.children.forEach(itx => {
                            let _rule_d = _rule.find(_res => _res.id == itx.id)
                            if (!_rule_d) {
                                //插入，并确保保留原始的maxScore值
                                _rule.push({
                                    ...itx,
                                    // 明确保留maxScore字段
                                    maxScore: itx.maxScore !== undefined ? itx.maxScore : ''
                                })
                            } else {
                                // 如果已存在，更新其maxScore值以确保使用最新数据
                                _rule_d.maxScore = itx.maxScore !== undefined ? itx.maxScore : ''
                            }
                        })
                        // 更新selectedIds
                        item.selectedIds = item.children.map(obj => obj.id)
                    }
                })

                // 移除错误的赋值，form.rules不需要设置为secondLevelRules
                this.rule_selected_lists = _r
            })
            this.get_rules().then(() => {

            })
        },
        //指标列表
        get_rules() {
            return new Promise((resolve) => {
                // 获取二级指标
                rule_list({ ...this.rule_query, level: 2 }).then(secondRes => {
                    this.secondLevelRules = secondRes.data
                    console.log('二级指标加载完成:', this.secondLevelRules)

                }).catch(() => {
                    console.log('加载二级指标失败')
                    resolve()
                })
            })
        },

        //添加组
        handleAddGroup() {
            console.log('添加指标项：', this.rule_selected_lists);
            this.rule_selected_lists.push({ name: '', children: [], selectedIds: [] })
            console.log('添加指标项后：', this.rule_selected_lists);
        },

        //切换
        handleChange(val, item) {
            // 添加空值检查
            if (!val || !Array.isArray(val) || val.length == 0) {
                item.children = []
                item.selectedIds = []
                item.secondItems = []
                return
            }

            // 更新selectedIds
            item.selectedIds = val;

            // 确保item.children是数组
            if (!item.children || !Array.isArray(item.children)) {
                item.children = []
            }

            let data = [];
            let arr = {};

            // 更新children
            val.forEach(itx => {
                // 安全地调用find方法
                let _data = item.children && Array.isArray(item.children) ? item.children.find(idx => idx && idx.id == itx) : null
                if (!_data) {
                    // 确保secondLevelRules是数组
                    let _r = this.secondLevelRules && Array.isArray(this.secondLevelRules) ?
                        this.secondLevelRules.find(idx => idx && idx.id == itx) : null
                    if (_r) {
                        // 创建新副本以避免直接修改原始数据
                        let newRule = { ..._r };
                        // 使用指标本身的maxScore值作为默认值，如果没有则设为空字符串
                        newRule.maxScore = _r.maxScore !== undefined ? _r.maxScore : '';
                        data.push(newRule)
                        arr[itx] = newRule
                    }
                } else {
                    // 保留已有的分数值和其他属性，不重置maxScore
                    arr[itx] = _data
                }
            });

            // 只保留用户选择的规则，不合并未选择的项
            item.children = Object.values(arr);


        },

        onSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false;
                }
            });
        },

        //删除组
        handleGroupDel(index) {
            // 在编辑模式下，如果有id，需要调用删除接口
            if (this.form.id && this.rule_selected_lists[index].id) {
                module_del_rule({ ids: [this.rule_selected_lists[index].id] }).then(res => {
                    if (res.code != 0) return this.$notify({ title: '失败', message: res.msg, type: 'error' });
                    this.$notify({ title: '成功', message: "删除成功", type: 'success' });
                    this.rule_selected_lists.splice(index, 1)
                })
            } else {
                this.rule_selected_lists.splice(index, 1)
            }
        },

        remoteMethod(query) {
            this.expert_query.keyword = query
            this.get_experts()
        },
        remoteMethodRule(query) {
            this.rule_query.name = query
            this.get_rules()
        },


        //req
        req() {
            let rules = [];
            this.rule_selected_lists.forEach(item => {
                let data = {
                    name: item.name,
                    templateId: item.templateId,
                    id: item.id,
                    children: []
                }
                if (item.children && Array.isArray(item.children)) {
                    // 提交完整的指标对象，而不仅仅是id和maxScore
                    item.children.forEach(itx => {
                        // 创建一个新对象，确保包含所有字段
                        let rule_itx = { ...itx };
                        // 只在maxScore未定义、为null或空字符串时才设置默认值0
                        // 否则保留用户在表格中输入的实际分数值
                        if (rule_itx.maxScore === undefined || rule_itx.maxScore === null || rule_itx.maxScore === '') {
                            rule_itx.maxScore = 0;
                        }
                        data.children.push(rule_itx)
                    })
                }

                rules.push(data)
            })
            let form = JSON.parse(JSON.stringify(this.form));

            // 根据是否有id来决定是添加还是编辑
            // 编辑模式
            if (!this.editable) {
                delete form.rules
            } else {
                form.rules = rules
            }


            save(form).then(res => {
                if (res.code != 0) return this.$notify({ title: '失败', message: res.msg, type: 'error' });
                this.$notify({ title: '成功', message: "更新成功", type: 'success' });
                this.$router.go(-1)
            })
        },



        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //关闭抽屉
        closeDrawer() {
            this.$router.go(-1)
        }
    }

}
</script>


<style lang="less" scoped>
// 全局样式重置，确保所有元素使用box-sizing
* {
    box-sizing: border-box;
}

// 整个抽屉内容容器
.drawer_form {
    width: 100%;
    height: 100%;
    padding: 0;
    position: relative;
    overflow: hidden;
}

// 表单容器
.demo-ruleForm {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
}

// 表单内容区域（可滚动部分）
.form-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;
    margin-bottom: 80px; // 为底部按钮留出空间
    width: 100%;

    // 自定义滚动条
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 123, 255, 0.1);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(0, 123, 255, 0.5);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 123, 255, 0.7);
    }
}

// 章节标题
.section-title {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    display: block;
    margin-bottom: 10px;
    clear: both; // 确保标题总是新的一行开始
}

// 表单区域样式
.form-section {
    width: 100%;
    margin-bottom: 20px;
    padding: 15px;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    border: 1px solid rgba(0, 123, 255, 0.3);
    box-sizing: border-box;
    position: relative; // 为蒙层提供定位参考
}

// 表单元素样式
.form-input,
.form-select,
.form-textarea {
    width: 100%;
    border-radius: 4px;
    transition: all 0.3s;

    &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }
}

.form-textarea {
    resize: vertical;
    min-height: 100px;
}

// 编辑模式下的蒙层样式
.edit-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    pointer-events: all;
    user-select: none;
    border-radius: 10px;

    .edit-overlay-text {
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
    }
}

// 添加卡片包装器，确保点击区域完全可用
.add-card-wrapper {
    position: relative;
    z-index: 20; // 高于其他元素
    width: 100%;
}

// 添加卡片样式
.add-card {
    margin: 15px 0;
    text-align: center;
    cursor: pointer;
    user-select: none;
    border: 2px dashed #007bff;
    background-color: transparent;
    color: #007bff;
    transition: all 0.3s;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    z-index: 15; // 确保卡片在最上层

    // 确保整个卡片都是可点击的
    /deep/ .el-card__body {
        cursor: pointer;
        padding: 20px;
    }

    &:hover {
        background-color: rgba(0, 123, 255, 0.1);
        border-color: #409eff;
        transform: translateY(-2px);
    }

    .add-card-content {
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
    }
}

// 备用添加按钮样式
.backup-add-btn {
    margin: 10px 0;
    width: 100%;
    position: relative;
    z-index: 20;
}

// 规则卡片样式
.rule-card {
    margin: 15px 0;
    // background-color: rgba(255, 255, 255, 0.1); // 增加背景不透明度以提高可见度
    background: none;
    border: 1px solid #007bff; // 更粗的边框使其更明显
    border-radius: 8px;
    overflow: visible; // 允许内容完全显示
    position: relative;
    z-index: 5; // 确保新增的规则卡片可见
    opacity: 1; // 确保完全不透明
    display: block; // 确保是块级元素
    min-height: 200px; // 设置最小高度确保可见
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2); // 添加阴影增强立体感
    transition: all 0.3s ease; // 添加过渡效果

    &:hover {
        box-shadow: 0 6px 20px rgba(0, 123, 255, 0.3); // 悬停时增强阴影
        border-color: #409eff; // 悬停时边框变色
    }

    // 直接样式穿透
    /deep/ .el-card__body {
        padding: 20px;
        background: none;
    }
}

// 分组头部样式
.group-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;

    .group-name-input {
        flex: 1;
    }

    .delete-btn {
        padding: 4px 12px;
    }
}

// 选择器容器样式
.select-container {
    margin-bottom: 12px;

    .rule-select {
        width: 100%;
    }
}

// 表格样式
.score-table {
    background-color: transparent;

    &::before,
    &::after {
        display: none;
    }

    .table-column {
        background-color: transparent;
        color: #fff;
    }
}

// 分数输入框样式
.score-input {
    width: 100px;
    text-align: center;
}

// 底部按钮区域
.form-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background-color: #052445;
    border-top: 1px solid rgba(0, 123, 255, 0.3);
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    box-sizing: border-box;
    z-index: 100;

    .cancel-btn,
    .submit-btn {
        min-width: 100px;
        padding: 8px 20px;
        font-size: 14px;
        border-radius: 4px;
    }

    .submit-btn {
        background-color: #007bff;
        border-color: #007bff;

        &:hover {
            background-color: #409eff;
            border-color: #409eff;
        }
    }
}


.form-section-title {
    font-size: 14px;
    color: #7ba8d0;
    margin-top: 10px;
    margin-bottom: 10px;
}

// Element UI 组件覆盖样式
/deep/ .el-form-item {
    margin-bottom: 20px;
}

/deep/ .el-form-item__label {
    color: #fff;
    font-weight: 500;
}

/deep/ .el-table__header-wrapper th {
    background-color: transparent;
    color: #fff;
    border-bottom: 1px solid rgba(0, 123, 255, 0.3);
}

/deep/ .el-table__body-wrapper td {
    background-color: transparent;
    color: #fff;
    border-bottom: 1px solid rgba(0, 123, 255, 0.1);
}

/deep/ .el-table__row:hover td {
    background-color: rgba(0, 123, 255, 0.1);
}

/deep/ .el-card__header {
    padding: 15px;
    background-color: rgba(0, 123, 255, 0.1);
    border-bottom: 1px solid rgba(0, 123, 255, 0.3);
}

/deep/ .el-card__body {
    padding: 15px;
}

/deep/ .el-divider--horizontal {
    margin: 0 0 20px 0;
    background: #007bff;
}
</style>
